import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../store/actions';
import axios from "axios";

import TenantDetails from './TenantDetails';

import {
  Paper, Typography, FormControl, IconButton, Container, TextField, FormControlLabel,
  Switch, Divider, Avatar, useMediaQuery, InputLabel, MenuItem, Select, Tabs, Tab
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBack from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';

import { isEmpty, uniqueId, cloneDeep } from 'lodash';
import filesize from "filesize";
import API from '../../../axios/api';

import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle,
} from './styles';

import Spinner from '../../../components/Spinner/index';
import confirm from '../../../UI/Confirm/confirm';
import PhotoUpload from '../../../UI/PhotoUpload';
import PhotoBarUploading from '../../../UI/PhotoBarUploading/PhotoBarUploading';
import ModalEditPhoto from '../../../UI/PhotoEditor/ModalEditor';
import TenantSites from "./TenantSites";
import Map from '../../../components/Map/index';
import MapMarker from '../../../components/MapMarker/index';

import {
  Appbar,
} from '../../Login/styles';
import TenantFeatureFlags from "./TenantFeatureFlags";
import TenantChangeEquipmentModel from "./TenantChangeEquipmentModel";
import TenantEditEquipmentFormMandatoryFields from "./TenantEdiEquipmentFormMandatoryFields";
import TenantLimitActionDeadline from "./TenantLimitActionDeadline";
import moment from "moment-timezone";
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import TenantQRCodeOptions from "./TenantQRCodeOptions";
import EFeatureFlags from "../../../utils/EFeatureFlags";
import TenantApiKeys from "./TenantAPIKey";
import TenantEquipmentsRegistrationLimit from "./TenantEquipmentsRegistrationLimit";
import TenantAccountables from "./TenantAccountables";

const AnyReactComponent = ({ text }) => <div>{text}</div>;

export default function Tenant(props) {
  const createLabelTimezone = (tz) => { // It creates the timezone label along with the GMT timezone
    const gmt = moment.tz(tz).format('Z');
    return { label: `${tz} (GMT${gmt})`, value: tz }
  }

  const dispatch = useDispatch();
  const matches = useMediaQuery('(min-width:1200px)');

  const [editMode, setEditMode] = useState(false);
  const [isNewData, setIsNewData] = useState(true);


  const [accountables, setAccountables] = useState([]);
  const [accountablesTenant, setAccountablesTenant] = useState([]);
  const [emailSuffixes, setEmailSuffixes] = useState([]);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [quicksightId, setQuicksightId] = useState("");
  const [reportSignature, setReportSignature] = useState(false);
  const [emailLanguage, setEmailLanguage] = useState("pt");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [zoom, setZoom] = useState(11);
  const [timezone, setTimezone] = useState(createLabelTimezone(moment.tz.guess()));
  const [timezones, setTimezones] = useState(moment.tz.names().map((tz) => createLabelTimezone(tz)));

  const [profile, setProfile] = useState([])
  const [blocked, setBlocked] = useState(false)
  const [blockedReason, setBlockedReason] = useState("")
  const [showFutureServices, setShowFutureServices] = useState(false);

  // Dashboard from other tenants
  const [dashboardFromOtherTenants, setDashboardFromOtherTenants] = useState([]);
  const [tenantsForSelect, setTenantsForSelect] = useState([]);
  const [searchTextTenants, setSearchTextTenants] = useState("");
  const [loadingTenants, setLoadingTenants] = useState(false);


  const [nameError, setNameError] = useState(false);
  const [profileError, setProfileError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [zoomError, setZoomError] = useState(false);
  const [zoomErrorMessage, setZoomErrorMessage] = useState("");
  const [tabValue , setTabValue] = useState(0);

  const fetchTenant = useCallback(
    () => dispatch(actions.fetchTenantsByIdSuperadmin(props.match.params.id))
  );

  const [modalPhoto, setModalPhoto] = useState();
  const [openModalAvatar, setOpenModalAvatar] = useState(false);

  const tenant = useSelector(state => state.tenants.tenant);
  const loadingTenant = useSelector(state => state.tenants.loading);

  const [featureFlags, setFeatureFlags] = useState([]);

  const postTenants = (body) => dispatch(actions.postTenants(body))
  const updateTenants = (body) => dispatch(actions.updateTenantsSuperadmin(props.match.params.id, body))
  const deleteTenants = (id) => dispatch(actions.deleteTenants(id))

  // Fetch tenants for dashboard select
  const fetchTenantsForSelect = useCallback((searchText = "") => {
    setLoadingTenants(true);
    const queryParams = `?page=1&limit=30&q=${searchText}&sort=name`;
    API.get('/tenants' + queryParams)
      .then(res => {
        const currentTenantId = props.match.params.id;
        const filtered = res.data.rows
          .filter(t => t._id !== currentTenantId)
          .map(t => ({ value: t._id, label: t.name }));
        setTenantsForSelect(filtered);
        setLoadingTenants(false);
      })
      .catch(() => {
        setLoadingTenants(false);
      });
  }, [props.match.params.id]);

  //check if is newEntrance or editing
  useEffect(() => {
    setIsNewData(props.match.params.id === 'new')
    if (props.match.params.id !== 'new') {
      fetchTenant();
    } else {
      setName("");
      setProfile([]);
      setBlocked(false);
      setBlockedReason('')
      setFeatureFlags([]);
      setDashboardFromOtherTenants([]);
    }
    // Initial fetch for tenants select
    fetchTenantsForSelect();
  }, [])

  // Fetch tenants when search text changes
  useEffect(() => {
    fetchTenantsForSelect(searchTextTenants);
  }, [searchTextTenants])

  // in case editing, populate fields
  useEffect(() => {
    if (!isEmpty(tenant) && props.match.params.id !== 'new') {
      setName(tenant.name)
      const profileArray = []
      profileArray.push(tenant.photo)
      setProfile(profileArray)
      setBlocked(tenant.blocked);
      setBlockedReason(tenant.blockedReason ? tenant.blockedReason : '');
      setShowFutureServices(tenant.showFutureServices);
      setEmailSuffixes(tenant.emailSuffixes)
      setPhone(tenant.phone);
      setQuicksightId(tenant.quicksightId);
      setReportSignature(tenant.reportSignature);
      setEmailLanguage(tenant.emailLanguage);
      setLatitude(tenant.latitude);
      setLongitude(tenant.longitude);
      setZoom(tenant.zoom);
      setFeatureFlags(tenant.featureFlags || []);
      if (tenant.timezone && tenant.timezone !== '') setTimezone(createLabelTimezone(tenant.timezone))

      // Populate dashboardFromOtherTenants
      if (tenant.dashboardFromOtherTenants && tenant.dashboardFromOtherTenants.length > 0) {
        // Fetch the names of the selected tenants
        const tenantIds = tenant.dashboardFromOtherTenants.map(t => ({ value: t._id, label: t.name }));
        setDashboardFromOtherTenants(tenantIds);
      } else {
        setDashboardFromOtherTenants([]);
      }

      localStorage.setItem('selectedTenant', props.match.params.id);
    }
  }, [tenant])


  const handleBack = () => {
    props.history.goBack();
  }

  const handleUploadPhoto = photo => {
    const uploadingFiles = photo.map(file => ({
      file,
      name: file.name,
      readableSize: filesize(file.size),
      preview: URL.createObjectURL(file),
      fileType: file.type,
      uploaded: false,
      error: false,
      url: null
    }))

    setProfile(uploadingFiles)
    uploadingFiles.forEach(processUpload);
    // setModalPhoto(uploadingFiles[0]);
    // setOpenModalAvatar(true);

  }

  const handleCloseModalAvatar = (file) => {
    let uploadedFile = [];
    if (file) {
      uploadedFile.push({
        file,
        _id: uniqueId(),
        name: file.name,
        readableSize: filesize(file.size),
        preview: URL.createObjectURL(file),
        fileType: file.type,
        uploaded: false,
        error: false,
        url: null
      });
      setProfile(uploadedFile)
      processUpload(uploadedFile[0])
    }
    setOpenModalAvatar(false);
  }

  const updateFile = (id, data) => {
    setProfile(prevUf => {
      return prevUf.map(uf => id === uf._id ? { ...uf, ...data } : uf)
    })
  };


  const processUpload = async uploadedFile => {

    const payloadToSign = {
      fileType: uploadedFile.fileType,
      name: uploadedFile.name
    };

    API.post("photos/signurl/superadmin", { file: payloadToSign }).then(signUrlRes => {
      axios.put(signUrlRes.data.url, uploadedFile.file, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile._id, {
            progress
          });
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `profile/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType
        }

        API.post("photos/superadmin", body)
          .then(response => {
            setProfileError(false);
            updateFile(uploadedFile._id, {
              uploaded: true,
              _id: response.data._id,
              url: response.data.url
            });
          })
          .catch(() => {
            updateFile(uploadedFile._id, {
              error: true
            });
          });
      })
    })
  }

  const handleChangeFeatureFlags = (flag, shouldInclude) => {
    if (shouldInclude) {
      setFeatureFlags([
        ...featureFlags.filter((flagName) => flagName !== flag),
        flag
      ])
    } else {
      setFeatureFlags([
        ...featureFlags.filter((flagName) => flagName !== flag),
      ])
    }
  }


  const handleClose = () => {
    // verifica se algo foi alterado
    // if (handleCloseComparison()) {
    confirm(`Deseja realmente sair sem salvar as alterações?`,
      {
        title: 'ALTERAÇÕES NÃO SALVAS',
        titleColor: 'red',
        disableBackdrop: true
      })
      .then(
        () => {
          console.log('continue editing');
        },
        async () => {
          // handleCloseRestoreDefault();
          setEditMode(false)
        },
      )
    // } else {
    //   setEditMode(false)
    // }
  }

  const handleDeleteTenant = (id) => {
    confirm(`Deseja realmente deletar esse colaborador?`,
      {
        title: 'DELETAR COLABORADOR',
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          deleteTenants(id)
        },
      )

  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let err = false;

    const body = {
      name,
      emailSuffixes,
      quicksightId,
      accountable: tenant?.accountable || '',
      accountables: accountables,
      accountablesTenant: accountablesTenant,
      phone,
      reportSignature,
      emailLanguage,
      latitude,
      longitude,
      zoom,
      timezone: timezone.value,
      blocked,
      blockedReason,
      showFutureServices,
      featureFlags,
      dashboardFromOtherTenants: dashboardFromOtherTenants.map(t => t.value)
    }

    if (zoom) {
      if (zoom < 1) {
        err = true;
        setZoomError(true);
        setZoomErrorMessage('O valor do zoom deve ser no mínimo 1');
      } else if (zoom > 17) {
        err = true;
        setZoomError(true);
        setZoomErrorMessage('O valor do zoom deve ser no máximo 17');
      }
    }
    
    if (profile.length > 0 && profile[0] && profile[0]._id) {
      body["photo"] = profile[0]._id
    }

    if (!err) {
      if (isNewData) {
        body.equipmentFormMandatoryFields = {
          area: false,
          company: false,
          serialNumber: false,
          brand: false,
          description: false,
          manufacturingDate: false,
          reference: false,
        }
        postTenants(body).then(result => {
          if (result === 'success') {
            props.history.goBack()
          }
        })
      } else {
        updateTenants(body).then(result => {
          if (result === 'success') {
            setEditMode(false)
          }
        })
      }
    }
  }

  const handleAddChip = (chip) => {
    let emailSuffixesClone = cloneDeep(emailSuffixes)
    emailSuffixesClone.push(chip);
    setEmailSuffixes(emailSuffixesClone)
  }

  const handleDeleteChip = (chip, index) => {
    let emailSuffixesClone = cloneDeep(emailSuffixes)
    emailSuffixesClone.splice(index, 1);
    setEmailSuffixes(emailSuffixesClone)
  }

  const handleChange = (_event, newValue) => {
    setTabValue(newValue);
  }

  const handleTimezoneSearch = (query) => {
    setTimezones(moment.tz.names().map((tz) => createLabelTimezone(tz))
      .filter((tz) => tz.label.includes((query.charAt(0).toUpperCase() + query.slice(1)).trim())))
  }

  const handleChangeTimezone = (tz) => {
    setTimezones(moment.tz.names().map((tz) => createLabelTimezone(tz)))
    setTimezone(tz)
  }

  return <>
    <ModalEditPhoto
      selectedFile={modalPhoto}
      open={openModalAvatar}
      onClose={handleCloseModalAvatar}
      title='Editar foto do Tenant'
    />
    <Appbar />
    <div style={styles.paper}>
      { props.match.params.id !== 'new' && <Tabs
          value={tabValue}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          style={{marginLeft: 80, textAlign: 'center'}}
        >
          <Tab label={'Infos Tenant'}/>
          <Tab label={'Campos Obrigatórios Formulários'}/>
        </Tabs>
      }
      
      <IconButton onClick={handleBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>
      <div style={matches ? styles.divContainer : styles.divContainerSmall}>
      { tabValue === 0 && <>
        <Container maxWidth='sm' style={{ ...styles.container, opacity: loadingTenant ? 0.3 : 1 }}>
          {loadingTenant && <Spinner overlay />}
          <Paper style={{ marginBottom: 10 }}>
            <FormStyled onSubmit={handleSubmit} style={styles.opacityContainer}>
              <DivFormTitle>
                <Typography variant='h6'>{props.match.params.id === 'new' ? 'Cadastro de Novo Tenant' : 'Infos Tenant'}</Typography>
                {!isNewData &&
                  <DivSubmitButtons>
                    {editMode ?
                      <>
                        <IconButton onClick={handleClose} size="large"><CloseIcon color='error' /></IconButton>
                        <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                      </> :
                      <>
                        <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                        <IconButton onClick={() => handleDeleteTenant(props.match.params.id)} size="large"><DeleteIcon /></IconButton>
                      </>
                    }
                  </DivSubmitButtons>
                }
              </DivFormTitle>
              <Divider />
              <>
                {!isNewData &&
                  <div style={styles.imageInput}>


                    {!editMode && !isNewData && profile && !profile[0] ?
                      <Avatar style={styles.avatar}>FOTO</Avatar>
                      : (<>
                        <PhotoUpload onUpload={handleUploadPhoto} photo={loadingTenant ? [] : profile} enabled={editMode || isNewData} />
                        <PhotoBarUploading photo={profile} />
                        {profileError ? <Typography style={{ color: "#f44336" }}>Aguarde o arquivo subir</Typography> : null}
                      </>)}
                  </div>
                }
                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    disabled={!isNewData && !editMode}
                    label='Tenant'
                    name='name'
                    onChange={event => { setNameError(false); return setName(event.target.value.toUpperCase()) }}
                    value={name}
                    error={nameError}
                    margin='normal' />
                </FormControl>
                {/* <FormControl fullWidth>
                    <ChipInput
                      disabled={!isNewData && !editMode}
                      value={emailSuffixes}
                      onAdd={(chip) => handleAddChip(chip)}
                      onDelete={(chip, index) => handleDeleteChip(chip, index)}
                      label='Domínios'
                    />
                </FormControl> */}
                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    disabled={!isNewData && !editMode}
                    label='Telefone'
                    name='phone'
                    onChange={event => { setPhoneError(false); return setPhone(event.target.value.toUpperCase()) }}
                    value={phone}
                    error={phoneError}
                    margin='normal' />
                </FormControl>
                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    disabled={!isNewData && !editMode}
                    label='Quicksight Dashboard ID'
                    name='quicksightid'
                    onChange={event => setQuicksightId(event.target.value)}
                    value={quicksightId}
                    margin='normal' />
                </FormControl>

                <FormControl variant="standard" style={styles.formControlMarginTop} fullWidth>
                  <InputLabel>Idioma do E-mail</InputLabel>
                  <Select
                    variant="standard"
                    disabled={!isNewData && !editMode}
                    label='Idioma'
                    name='idioma'
                    onChange={event => setEmailLanguage(event.target.value)}
                    value={emailLanguage}
                    margin='normal'>
                    <MenuItem value={'pt'}>PORTUGUÊS</MenuItem>
                    <MenuItem value={'en'}>ENGLISH</MenuItem>
                    <MenuItem value={'esp'}>ESPAÑOL</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    disabled={!isNewData && !editMode}
                    label='Latitude'
                    name='latitude'
                    onChange={event => setLatitude(event.target.value)}
                    value={latitude}
                    margin='normal' />
                </FormControl>
                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    disabled={!isNewData && !editMode}
                    label='Longitude'
                    name='longitude'
                    onChange={event => setLongitude(event.target.value)}
                    value={longitude}
                    margin='normal' />
                </FormControl>
                <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    disabled={!isNewData && !editMode}
                    label='Zoom'
                    name='zoom'
                    onChange={event => {
                      setZoomError(false);
                      setZoomErrorMessage("");
                      setZoom(event.target.value);
                    }}
                    value={zoom}
                    error={zoomError}
                    helperText={zoomErrorMessage}
                    type="number"
                    margin='normal' />
                </FormControl>
                <FormControl variant="standard" fullWidth>
                  <Autocomplete
                    loading={false} // sent to isLoading
                    label="Fuso horário"
                    data={ timezones } // sent to options
                    onSelectValue={handleChangeTimezone} // sent to onChange
                    valueSelected={timezone} // sent to value
                    newSearchText={handleTimezoneSearch}
                    name='equipment'
                    disabled={!isNewData && !editMode}
                  />
                </FormControl>
                <FormControl variant="standard" fullWidth style={styles.formControlMarginTop}>
                  <Autocomplete
                    loading={loadingTenants}
                    label="Dashboards de outros Tenants"
                    placeholder="Buscar tenants..."
                    data={tenantsForSelect}
                    onSelectValue={(selected) => setDashboardFromOtherTenants(selected || [])}
                    valueSelected={dashboardFromOtherTenants}
                    newSearchText={setSearchTextTenants}
                    name='dashboardFromOtherTenants'
                    disabled={!isNewData && !editMode}
                    isMulti
                  />
                </FormControl>
                <Container style={styles.switchesContainer}>
                  <FormControl variant="standard" fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='bloqueada'
                          checked={blocked}
                          onChange={event => setBlocked(event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Bloquear Tenant"
                    />
                  </FormControl>

                  {blocked && <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    disabled={!isNewData && !editMode}
                    label='Motivo de bloqueio'
                    name='blockedReason'
                    onChange={event => { return setBlockedReason(event.target.value) }}
                    value={blockedReason}
                    margin='normal' />
                  </FormControl> }
                 
                  <FormControl variant="standard" fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='report signature'
                          checked={reportSignature}
                          onChange={event => setReportSignature(event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Exibir campo de assinatura no relatório"
                    />
                  </FormControl>
                  <FormControl variant="standard" fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='futureServices'
                          checked={showFutureServices}
                          onChange={event => setShowFutureServices(event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Mostrar e gerar Serviços Futuros"
                    />
                  </FormControl>
                  <FormControl variant="standard" fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='powerBiDashboard'
                          checked={featureFlags.includes(EFeatureFlags.POWER_BI_DASHBOARD)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.POWER_BI_DASHBOARD, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="PowerBi Dashboard"
                    />
                  </FormControl>
                  <FormControl variant="standard" fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='singleQrCode'
                          checked={featureFlags.includes(EFeatureFlags.SINGLE_QRCODE)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.SINGLE_QRCODE, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="1 QR Code por página"
                    />
                  </FormControl>
                  <FormControl variant="standard" fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='blockUserGallery'
                          checked={featureFlags.includes(EFeatureFlags.BLOCK_USER_GALLERY)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.BLOCK_USER_GALLERY, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Bloquear uso da galeria no app (somente camera habilitada)"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='answerAllQuestionsWithNA'
                          checked={featureFlags.includes(EFeatureFlags.NA_AS_DEFAULT_ANSWER)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.NA_AS_DEFAULT_ANSWER, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Perguntas dos serviços vem respondidas com N/A"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='showNotificationWebhooks'
                          checked={featureFlags.includes(EFeatureFlags.NOTIFICATIONS_WEBHOOKS)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.NOTIFICATIONS_WEBHOOKS, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Mostrar área de Webhooks de Notiticações"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='blockServiceCreationWithoutQrcodeScanning'
                          checked={featureFlags.includes(EFeatureFlags.BLOCK_SERVICE_CREATION_WITHOUT_QRCODE_SCANNING)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.BLOCK_SERVICE_CREATION_WITHOUT_QRCODE_SCANNING, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Serviços só podem ser criados via leitor de QRCode no App"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='scheduledServices'
                          checked={featureFlags.includes(EFeatureFlags.SCHEDULED_SERVICES)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.SCHEDULED_SERVICES, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Agendamento de serviços"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='blockQrCodeAccessWithouLogin'
                          checked={featureFlags.includes(EFeatureFlags.BLOCK_QR_CODE_READING_WITHOUT_LOGIN)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.BLOCK_QR_CODE_READING_WITHOUT_LOGIN, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="QR Codes de equipamentos precisam de login para serem lidos"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='finishedActionsAdminsNotification'
                          checked={featureFlags.includes(EFeatureFlags.FINISHED_ACTIONS_ADMINS_NOTIFICATION)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.FINISHED_ACTIONS_ADMINS_NOTIFICATION, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Administradores são notificados quando ações forem finalizadas"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='blockRetroactiveServicesForAnalystsAndContractors'
                          checked={featureFlags.includes(EFeatureFlags.BLOCK_RETROACTIVE_SERVICES_FOR_ANALYSTS_AND_CONTRACTORS)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.BLOCK_RETROACTIVE_SERVICES_FOR_ANALYSTS_AND_CONTRACTORS, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Bloquear criação de serviços retroativos para Analistas e Terceiros"
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Switch
                          disabled={!isNewData && !editMode}
                          name='blockEquipmentCreationInSitesWithoutAccess'
                          checked={featureFlags.includes(EFeatureFlags.BLOCK_EQUIPMENT_CREATION_IN_SITES_WITHOUT_ACCESS)}
                          onChange={event => handleChangeFeatureFlags(EFeatureFlags.BLOCK_EQUIPMENT_CREATION_IN_SITES_WITHOUT_ACCESS, event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Bloquear criação de equipamentos em sites aos quais o usuário não tem acesso"
                    />
                  </FormControl>
                </Container>                 
                <Map zoom={zoom} center={{ lat: latitude, lng: longitude}} style={{ height: 400 }} items={[<MapMarker latitude={latitude} longitude={longitude} />]}/>
                <TenantAccountables
                  isNewData={isNewData}
                  editMode={editMode}
                  setAccountablesForBody={setAccountables}
                  setAccountablesTenantForBody={setAccountablesTenant}
                />
              </>
              {isNewData &&
                <DivSubmitButtons>
                  <IconButton onClick={props.history.goBack} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
                  <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
                </DivSubmitButtons>}
            </FormStyled>
          </Paper>
          <div style={styles.containerSpacer}></div>
          <TenantFeatureFlags {...props} />
          <TenantApiKeys />

        </Container>
        <Container maxWidth='sm' style={styles.container}>
          {props.match.params.id !== 'new' && <>
            <TenantEquipmentsRegistrationLimit />
            <div style={styles.containerSpacer}></div>
            <TenantDetails />
            <div style={styles.containerSpacer}></div>
            <TenantSites />
            <div style={styles.containerSpacer}></div>
            <TenantChangeEquipmentModel tenantId={props.match.params.id}/>
            <TenantLimitActionDeadline />
            <TenantQRCodeOptions />
          </>}
        </Container>
        </>}

        {(tabValue === 1 && props.match.params.id !== 'new') && <>
          <TenantEditEquipmentFormMandatoryFields />
        </>}
      </div>
    </div>
  </>;
}

const styles = {
  paper: {
    marginTop: 90,
  },
  arrowBack: {
    position: 'fixed',
    margin: 10,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 50,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: 'relative'
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20,
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  opacityContainer: {
    // opacity: loadingEmployee ? '0.3' : '1'
  },
  formLabels: {
    display: 'flex',
    margin: '20px 0',
    color: 'grey',
  },
  formLabelTitle: {
    color: '#000',
    marginRight: 10,
  },
  formLabelValue: {
    fontWeight: 'bold',
  },
  containerSpacer: {
    marginBottom: "10px"
  },
  formControlMarginTop: {
    marginTop: '10px'
  },
  switchesContainer: {
    margin: '1rem 0',
    paddingLeft: 0,
  }
}
